import { useState, useEffect, useMemo, useCallback } from "react";
import styles from "./styles.module.css";
import Heading from "../../components/shared-modules/Heading";
import StatsCard from "../../components/shared-modules/stats-card";
import SearchBar from "../../components/shared-modules/SearchBar";
import Tabs from "../../components/inventory/modules/Tabs/Tabs";
import Table from "../../components/table";
import StatusSelector from "../../components/inventory/detail/StatusSelector";
import AlertDialog from "../../components/alert-dialogue";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  getWarehouseBoxes,
  getIndividualDevices,
} from "../../services/inventory/detail";

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../components/ui/select";
import Button from "../../components/button-v1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaEdit } from "react-icons/fa";
import {
  faArrowsUpDownLeftRight,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

const OfficeInventory = () => {
  const currentLocation = JSON.parse(sessionStorage.getItem("current_loc"));
  const [inventoryTab, setInventoryTab] = useState("individual");
  const [bulkSearchTerm, setBulkSearchTerm] = useState("");
  const [deviceSearchTerm, setDeviceSearchTerm] = useState("");
  const [deviceStatus, setDeviceStatus] = useState("");
  const deviceStatusOptions = [
    { value: "linked", label: "Linked" },
    { value: "unlinked", label: "Unlinked" },
    { value: "refurbished", label: "Refurbished" },
  ];

  const locationOptions = [
    // { value: "austin-office", label: "Austin Office" },
    // { value: "houston-warehouse", label: "Houston Warehouse" },
    // { value: "dallas-office", label: "Dallas Office" },
    // { value: "san-antonio-facility", label: "San Antonio Facility" },
    // { value: "fort-worth-center", label: "Fort Worth Center" },
    { value: "warehouse", label: "Warehouse" },
  ];

  const inventoryTabs = [
    { id: "bulk", label: "Bulk" },
    { id: "individual", label: "Individual" },
  ];

  // Data/loading state cloned from InventorySection
  const [apiLoading, setApiLoading] = useState(false);
  const [boxes, setBoxes] = useState([]);
  const [individualDevices, setIndividualDevices] = useState([]);

  // Selection state per tab
  const [selectedParentBoxes, setSelectedParentBoxes] = useState([]);
  const [selectedIndividualDevices, setSelectedIndividualDevices] = useState(
    []
  );

  // Delete dialog state
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [itemPendingDelete, setItemPendingDelete] = useState(null);

  // Move dialog state
  const [isMoveDialogOpen, setIsMoveDialogOpen] = useState(false);
  const [itemPendingMove, setItemPendingMove] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState("warehouse");

  const handleOpenDelete = (item) => {
    setItemPendingDelete(item);
    setIsDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    // Integrate delete API/mutation here. For now, just close the dialog
    setIsDeleteDialogOpen(false);
    setItemPendingDelete(null);
  };

  const handleOpenMove = (item) => {
    setItemPendingMove(item);
    setIsMoveDialogOpen(true);
    setSelectedDestination("");
  };

  const handleCloseMove = () => {
    setIsMoveDialogOpen(false);
    setItemPendingMove(null);
    setSelectedDestination("");
  };

  const handleConfirmMove = () => {
    if (!selectedDestination) {
      alert("Please select a destination location");
      return;
    }

    // Integrate move API/mutation here
    console.log("Moving item:", itemPendingMove, "to:", selectedDestination);

    // For now, just close the dialog
    handleCloseMove();
  };

  const bulkData = [
    {
      id: "TBX-1001",
      caseManager: "John Doe",
      type: "Toca Box",
      date: "2025-09-14",
      location: "Austin Office",
      serialRegNo: "TNV-BOX-9001",
      quantity: 10,
      status: "linked",
    },
    {
      id: "TBX-1002",
      caseManager: "Jane Smith",
      type: "Toca Box",
      date: "2025-09-20",
      location: "Houston Warehouse",
      serialRegNo: "TNV-BOX-9002",
      quantity: 8,
      status: "unlinked",
    },
    {
      id: "TBX-1003",
      caseManager: "Sam Carter",
      type: "Toca Box",
      date: "2025-10-01",
      location: "Dallas Office",
      serialRegNo: "TNV-BOX-9003",
      quantity: 12,
      status: "linked",
    },
    {
      id: "TBX-1004",
      caseManager: "Michelle Lee",
      type: "Toca Box",
      date: "2025-10-05",
      location: "Austin Office",
      serialRegNo: "TNV-BOX-9004",
      quantity: 6,
      status: "refurbished",
    },
    {
      id: "TBX-1005",
      caseManager: "John Doe",
      type: "Toca Box",
      date: "2025-10-10",
      location: "Houston Warehouse",
      serialRegNo: "TNV-BOX-9005",
      quantity: 15,
      status: "linked",
    },
    {
      id: "TBX-1006",
      caseManager: "Jane Smith",
      type: "Toca Box",
      date: "2025-10-12",
      location: "Dallas Office",
      serialRegNo: "TNV-BOX-9006",
      quantity: 9,
      status: "unlinked",
    },
    {
      id: "TBX-1007",
      caseManager: "Sam Carter",
      type: "Toca Box",
      date: "2025-10-15",
      location: "Austin Office",
      serialRegNo: "TNV-BOX-9007",
      quantity: 7,
      status: "linked",
    },
    {
      id: "TBX-1008",
      caseManager: "Michelle Lee",
      type: "Toca Box",
      date: "2025-10-18",
      location: "Houston Warehouse",
      serialRegNo: "TNV-BOX-9008",
      quantity: 11,
      status: "refurbished",
    },
    {
      id: "TBX-1009",
      caseManager: "John Doe",
      type: "Toca Box",
      date: "2025-10-20",
      location: "Dallas Office",
      serialRegNo: "TNV-BOX-9009",
      quantity: 5,
      status: "unlinked",
    },
    {
      id: "TBX-1010",
      caseManager: "Jane Smith",
      type: "Toca Box",
      date: "2025-10-22",
      location: "Austin Office",
      serialRegNo: "TNV-BOX-9010",
      quantity: 13,
      status: "linked",
    },
  ];
  const individualData = [
    {
      id: "DEV-2001",
      caseManager: "John Doe",
      type: "BP Cuff",
      serialImei: "IMEI-3567890001",
      date: "2025-10-01",
      location: "Austin Office",
      status: "linked",
    },
    {
      id: "DEV-2002",
      caseManager: "Jane Smith",
      type: "Weight Scale",
      serialImei: "SN-WS-22002",
      date: "2025-10-02",
      location: "Houston Warehouse",
      status: "unlinked",
    },
    {
      id: "DEV-2003",
      caseManager: "Sam Carter",
      type: "Glucometer",
      serialImei: "IMEI-3567890003",
      date: "2025-10-03",
      location: "Dallas Office",
      status: "linked",
    },
    {
      id: "DEV-2004",
      caseManager: "Michelle Lee",
      type: "Pulse Oximeter",
      serialImei: "SN-PO-44004",
      date: "2025-10-04",
      location: "Austin Office",
      status: "refurbished",
    },
    {
      id: "DEV-2005",
      caseManager: "John Doe",
      type: "BP Cuff",
      serialImei: "IMEI-3567890005",
      date: "2025-10-05",
      location: "Houston Warehouse",
      status: "linked",
    },
    {
      id: "DEV-2006",
      caseManager: "Jane Smith",
      type: "Weight Scale",
      serialImei: "SN-WS-22006",
      date: "2025-10-06",
      location: "Dallas Office",
      status: "unlinked",
    },
    {
      id: "DEV-2007",
      caseManager: "Sam Carter",
      type: "Glucometer",
      serialImei: "IMEI-3567890007",
      date: "2025-10-07",
      location: "Austin Office",
      status: "linked",
    },
    {
      id: "DEV-2008",
      caseManager: "Michelle Lee",
      type: "Pulse Oximeter",
      serialImei: "SN-PO-44008",
      date: "2025-10-08",
      location: "Houston Warehouse",
      status: "refurbished",
    },
    {
      id: "DEV-2009",
      caseManager: "John Doe",
      type: "BP Cuff",
      serialImei: "IMEI-3567890009",
      date: "2025-10-09",
      location: "Dallas Office",
      status: "unlinked",
    },
    {
      id: "DEV-2010",
      caseManager: "Jane Smith",
      type: "Weight Scale",
      serialImei: "SN-WS-22010",
      date: "2025-10-10",
      location: "Austin Office",
      status: "linked",
    },
    {
      id: "DEV-2011",
      caseManager: "Sam Carter",
      type: "Glucometer",
      serialImei: "IMEI-3567890011",
      date: "2025-10-11",
      location: "Houston Warehouse",
      status: "linked",
    },
    {
      id: "DEV-2012",
      caseManager: "Michelle Lee",
      type: "Pulse Oximeter",
      serialImei: "SN-PO-44012",
      date: "2025-10-12",
      location: "Dallas Office",
      status: "unlinked",
    },
  ];

  // Transform rows to match columns

  const filteredBulk = useMemo(() => {
    const term = (bulkSearchTerm || "").toLowerCase();
    if (!term) return bulkData;
    return bulkData.filter((row) =>
      String(row.serialRegNo || row.id || "")
        .toLowerCase()
        .includes(term)
    );
  }, [bulkSearchTerm, bulkData]);

  const filteredIndividuals = useMemo(() => {
    const term = (deviceSearchTerm || "").toLowerCase();
    if (!term) return individualData;
    return individualData.filter((row) =>
      String(row.serialImei || "")
        .toLowerCase()
        .includes(term)
    );
  }, [deviceSearchTerm, individualData]);

  const filteredDevices =
    inventoryTab === "bulk" ? filteredBulk : filteredIndividuals;

  // Selection handlers
  const handleParentSelectionChange = (selectedIds) => {
    setSelectedParentBoxes(selectedIds);
  };
  const handleIndividualSelectionChange = (selectedIds) => {
    setSelectedIndividualDevices(selectedIds);
  };

  const getCurrentSelectedDevices = () =>
    inventoryTab === "bulk" ? selectedParentBoxes : selectedIndividualDevices;
  const getCurrentDeviceSelectionHandler = () =>
    inventoryTab === "bulk"
      ? handleParentSelectionChange
      : handleIndividualSelectionChange;

  const handleRowClick = (row) => {
    // Placeholder: open details modal later
    console.debug("Row clicked", row);
  };

  const ActionButtons = ({ item, onEdit, onMove, onDelete }) => (
    <div className={styles.action_buttons}>
      {/* <button
        className={styles.action_btn}
        // onClick={(e) => {
        //   e.stopPropagation();
        //   onEdit(item);
        // }}
        title="Edit"
      >
        <FontAwesomeIcon icon={faEdit} />
      </button> */}
      <button
        className={styles.action_btn}
        onClick={(e) => {
          e.stopPropagation();
          onMove(item);
        }}
        title="Move"
      >
        <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
      </button>
      {/* <button
        className={styles.action_btn}
        onClick={(e) => {
          e.stopPropagation();
          onDelete && onDelete(item);
        }}
        title="Delete"
      >
        <FontAwesomeIcon icon={faTrash} />
      </button> */}
    </div>
  );

  const statusColorMap = {
    Linked: { color: "#dbeafe", text: "#1e40af", dotColor: "#1e40af" },
    Unlinked: { color: "#fef3c7", text: "#d97706", dotColor: "#d97706" },
    refurbished: { color: "#dcfce7", text: "#16a34a", dotColor: "#16a34a" },
  };

  const bulkDevicesColumns = [
    { key: "id", label: "Toca Box", alignLeft: true, sorting: false },
    {
      key: "caseManager",
      label: "Case Manager",
      alignLeft: true,
      sorting: false,
    },
    { key: "type", label: "Box Type", alignLeft: true, sorting: false },
    { key: "date", label: "Date", alignLeft: true, sorting: false },
    { key: "location", label: "Location", alignLeft: true, sorting: false },
    {
      key: "serialRegNo",
      label: "Tenovi Box ",
      alignLeft: true,
      sorting: false,
    },
    {
      key: "quantity",
      label: "Quantity",
      sorting: false,
      alignLeft: true,
      render: (device) => (
        <span className={styles.device_count}>{device.quantity}</span>
      ),
    },
    {
      key: "status",
      label: "Status",
      sorting: false,
      alignLeft: true,
      render: (box) => {
        const currentStatus = box.status || box.inventory_status;
        return (
          <div
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <StatusSelector
              id={`bulk-${box.id}`}
              currentStatus={currentStatus}
              statusColorMap={statusColorMap}
              // onStatusChange={(newStatus) =>
              //   handleStatusChange(box, newStatus, true)
              // }
              // openDropdownId={openDropdownId}
              // setOpenDropdownId={setOpenDropdownId}
            />
          </div>
        );
      },
    },

    {
      key: "actions",
      label: "Actions",
      sorting: false,
      render: (device) => (
        <ActionButtons
          item={device}
          // onEdit={handleEditDevice}
          onMove={handleOpenMove}
          onDelete={handleOpenDelete}
        />
      ),
    },
  ];

  const individualDevicesColumns = [
    { key: "caseManager", label: "Case Manager", alignLeft: true },
    { key: "type", label: "Device Type", alignLeft: true },
    { key: "serialImei", label: "Serial/IMEI", alignLeft: true },
    { key: "date", label: "Date", alignLeft: true },
    { key: "location", label: "Location", alignLeft: true },
    {
      key: "status",
      label: "Status",
      sorting: false,
      alignLeft: true,
      render: (device) => {
        const currentStatus = device.status;
        return (
          <div
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <StatusSelector
              currentStatus={currentStatus}
              statusColorMap={statusColorMap}
              // onStatusChange={(newStatus) =>
              //   handleStatusChange(device, newStatus, false)
              // }
              // openDropdownId={openDropdownId}
              // setOpenDropdownId={setOpenDropdownId}
            />
          </div>
        );
      },
    },
    {
      key: "actions",
      label: "Actions",
      sorting: false,
      render: (device) => (
        <ActionButtons
          item={device}
          // onEdit={handleEditDevice}
          onMove={handleOpenMove}
          onDelete={handleOpenDelete}
        />
      ),
    },
  ];

  const getCurrentDeviceColumns = () => {
    return inventoryTab === "bulk"
      ? bulkDevicesColumns
      : individualDevicesColumns;
  };

  useEffect(() => {
    console.log("selected-individual", selectedIndividualDevices);
    console.log("selected pareint", selectedParentBoxes);
  }, [selectedIndividualDevices, selectedParentBoxes]);

  return (
    <main className={styles.container}>
      <Heading
        title="Inventory details"
        content={
          <main className={styles.content_container}>
            <section className={styles.statsContainer}>
              <StatsCard
                title="Total Devices"
                value={200}
                progressPercentage={50}
              />
              <StatsCard
                title="Linked Devices"
                value={120}
                progressPercentage={40}
              />
              <StatsCard
                title="Unlinked Devices"
                value={80}
                progressPercentage={10}
              />
            </section>

            <section className={styles.inventoryTab_container}>
              <Tabs
                tabs={inventoryTabs}
                activeTab={inventoryTab}
                onChange={setInventoryTab}
                variant="secondary"
                size="small"
              />
            </section>

            <section className={styles.actions_container}>
              <SearchBar
                searchTerm={
                  inventoryTab === "bulk" ? bulkSearchTerm : deviceSearchTerm
                }
                onSearchChange={
                  inventoryTab === "bulk"
                    ? setBulkSearchTerm
                    : setDeviceSearchTerm
                }
                placeholder={
                  inventoryTab === "bulk"
                    ? "Search by box id"
                    : "Search by serial/imei"
                }
                maxWidth="300px"
              />
              <Select
                value={deviceStatus}
                onChange={(val) => setDeviceStatus(val)}
                placeholder="Select device status"
                className={styles.action_filter_status}
              >
                <SelectTrigger>
                  <SelectValue placeholder="select device status" />
                </SelectTrigger>
                <SelectContent>
                  {deviceStatusOptions.map((opt) => (
                    <SelectItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </section>

            <section className={styles.table_container}>
              <Table
                columns={getCurrentDeviceColumns()}
                data={filteredDevices}
                height={600}
                isRowClickable={true}
                onRowClick={handleRowClick}
                loading={apiLoading}
                showCheckboxes={true}
                onSelectionChange={getCurrentDeviceSelectionHandler()}
                selectedIds={getCurrentSelectedDevices()}
                key={`${inventoryTab}-${filteredDevices.length}`}
              />
            </section>

            <section className={styles.bulk_actions_container}>
              <Button variant="ghost">
                Move Selected ({getCurrentSelectedDevices()?.length})
              </Button>
              <Button>Move All ({filteredDevices?.length})</Button>
            </section>
          </main>
        }
      />

      <Dialog open={isMoveDialogOpen} onOpenChange={setIsMoveDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Move Item</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <div className={styles.move_dialog_content}>
              <div className={styles.move_dialog_form}>
                <label className={styles.move_dialog_label}>
                  Destination Location: <strong>Warehouse</strong>
                </label>
                {/* <Select
                  disabled
                  value={selectedDestination}
                  onChange={(val) => setSelectedDestination(val)}
                  placeholder="Select destination location"
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select destination location" />
                  </SelectTrigger>
                  <SelectContent >
                    {locationOptions.map((location) => (
                      <SelectItem key={location.value} value={location.value}>
                        {location.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select> */}
              </div>
            </div>
          </DialogBody>
          <DialogFooter>
            <Button variant="ghost" onClick={handleCloseMove}>
              Cancel
            </Button>
            <Button onClick={handleConfirmMove}>Move</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <AlertDialog
        open={isDeleteDialogOpen}
        setOpen={setIsDeleteDialogOpen}
        title="Delete Device"
        description={`Are you sure you want to delete ${
          itemPendingDelete?.id || "this item"
        }?`}
      >
        <Button
          variant="normal"
          size="default"
          onClick={() => setIsDeleteDialogOpen(false)}
        >
          Cancel
        </Button>
        <Button variant="danger" size="default" onClick={handleConfirmDelete}>
          Delete
        </Button>
      </AlertDialog>
    </main>
  );
};

export default OfficeInventory;
